/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoUpdateBankTransferPayment } from '../../models/dto-update-bank-transfer-payment';

export interface BookingControllerUpdateRefundStatus$Params {
  payment_identifier: string;
      body: DtoUpdateBankTransferPayment
}

export function bookingControllerUpdateRefundStatus(http: HttpClient, rootUrl: string, params: BookingControllerUpdateRefundStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerUpdateRefundStatus.PATH, 'patch');
  if (params) {
    rb.path('payment_identifier', params.payment_identifier, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

bookingControllerUpdateRefundStatus.PATH = '/booking/payment/refunds/{payment_identifier}';
